module.exports = __webpack_public_path__ + "static/media/Scan 4.1cc56a82.jpeg";